import {useWatch} from 'react-hook-form'

import {useFieldConfigurationContext} from '../../configuration/useConfigurationContext'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'

export const useRetarder = () => {
  const {control, setValue, formState: {defaultValues, errors}} = useOrderProcessFormContext()
  const retarderConfiguration = useFieldConfigurationContext('retarder')

  const retarder = useWatch({
    control,
    name: 'retarder'
  })

  const defaultRetarder = defaultValues?.retarder

  const setRetarder = (newRetarder: number) => {
    if (!retarderConfiguration.isEnabled) {
      return
    }

    setValue(
      'retarder',
      {retarder: newRetarder, retarderUom: retarderConfiguration?.uom},
      {shouldValidate: true}
    )
  }

  return {
    retarder,
    defaultRetarder,
    setRetarder,
    retarderConfiguration,
    error: errors.retarder
  }
}
